module.exports = __webpack_public_path__ + "static/media/folder.b4cd0ddf.svg";